import pumppuClass from "src/data/pumppuClass";
import asiakasClass from "src/data/asiakas/asiakasClass";
import tyomaaClass from "src/data/tyomaaClass";
import tilaClass from "src/data/tilaClass";
import personClass from "src/data/person/personClass";
import keikkaAuthClass from "src/data/auth/keikkaAuthClass";
import {
  aikaStringShort,
  checkResponse,
  hashCode,
  isValidDate,
  kestoString,
  myReplacer,
  pvmStringLong,
} from "src/components/js/statics1";
import authClass from "../auth/auth";
import laskutusClass from "../laskutusClass";
import { sha256 } from "js-sha256";
import handleKeikkaChange from "./handleKeikkaChange";
import betoniClass from "../betoni/betoniClass";
import starsClass from "../starsClass";
import errorsClass from "../system/errorsClass";
import keikkaModulesClass from "../keikkaModulesClass";
import { socketOnSave } from "../system/socketClass";

export default class keikkaClass {
  constructor(personId, keikkaId = 0, ownerAsiakasId = null) {
    this.isLoading = true;
    this.isBackgroundLoading = false;
    this.isLoaded = false;
    this.keikkaId = keikkaId;
    this.foreignKey = null;
    this.lockedString = "";
    this.isLocked = false; // if true, then the keikka is locked and cannot be edited
    this.betoni = [new betoniClass()];
    this.betoniToimittaja = new asiakasClass();
    this.pumppuToimittaja = new asiakasClass();
    this.lattiaToimittaja = new asiakasClass();
    this.laskutus = new laskutusClass();
    this.tyomaa = new tyomaaClass();
    this.pumppu = new pumppuClass();
    this.asiakas = new asiakasClass();
    this.keikkaContactPerson = new personClass();
    this.tila = new tilaClass();
    this.keikkaComment = null;
    this.keikkaOtsikko = null;
    this.originaluniqueHash = "";
    this.auth = new keikkaAuthClass();
    this.handleChange = new handleKeikkaChange(this, personId);
    this.stars = new starsClass();
    this.errors = new errorsClass();
    this.modules = new keikkaModulesClass(keikkaId);
    this.varmenneDB = undefined;
    this.ownerAsiakasId = ownerAsiakasId;
    this.isKeikka = true;
    this.isPalkki = false;
  }

  getBetoni(keikkaBetoniId) {
    return this.betoni.find((b) => b.keikkaBetoniId === keikkaBetoniId);
  }
  setBetoni(_betoni, keikkaBetoniID) {
    const index = this.betoni.findIndex((b) => b.keikkaBetoniId === keikkaBetoniID);
    this.betoni[index] = _betoni;
  }

  keikkaCommentString = () => {
    if (this.keikkaComment == null) {
      return "";
    } else {
      return this.keikkaComment.replace("m2", "m²").replace("m3", "m³");
    }
  };

  //#region saveData
  saveKeikkaMainPersonPersonToDB = (token, socket, personId = null) => {
    if (this.keikkaId === 0) return;
    const requestOptions = {
      method: "POST",
      headers: {
        "x-access-token": `${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        keikkaId: this.keikkaId,
        personId: this.keikkaContactPerson.personId,
      }),
    };
    fetch(import.meta.env.VITE_SERVER_URL + "/api/keikka/person/set", requestOptions)
      .then(() => {
        // send socket event TODO:personId TODO:personId
        const s = new socketOnSave(personId, socket, null, "keikkaData", "save", this.keikkaId);
        s.keikkaData = this;
        s.comment = "Tallennettu henkilö";
        s.function = "saveKeikkaMainPersonPersonToDB";
        s.emitSave();
      })
      .catch((error) => console.log(error));
  };

  setAuthDataViaFetch = async (personId, keikkaId, tyomaaId, asiakasId, keikkaTilaId, token) => {
    const _auth = new authClass();
    await _auth.init(personId, keikkaId, tyomaaId, asiakasId, keikkaTilaId, token);
    this.tyomaa.auth = _auth.tyomaaAuth;
    this.asiakas.auth = _auth.asiakasAuth;
    this.auth = _auth.keikkaAuth;
    // Reset keikkaData if not allowed to read
    if (!_auth.tyomaaAuth.read && !_auth.keikkaAuth.read && !_auth.asiakasAuth.read) {
      this.keikkaId = 0;
      this.tyomaa.tyomaaId = 0;
      this.asiakas.asiakasId = 0;
      this.tila.keikkaTilaSelite = "2. Ei pääsyä";
      this.tila.keikkaTilaId = -100;
      this.keikkaTilaCategory = "3. Ei pääsyä";
      return new authClass();
    }
    return this;
  };
  //#region keikkaPerson and keikkaContactPerson

  // create json string without circular references
  json() {
    const replacerWrapper = (key, value) => myReplacer(key, value, "keikka");
    return JSON.stringify(this, replacerWrapper, 2);
  }

  get totM3() {
    let _m3 = 0;
    this.betoni.forEach((betoni) => (_m3 += Number(betoni.m3)));
    return _m3;
  }

  get smsString() {
    let msg = "";

    let totM3 = 0;
    let betonit = "";
    for (let i = 0; i < this.betoni.length; i++) {
      const b1 = this.betoni[i].m3 + "m3 ";
      const b2 = this.betoni[i].betoniString;
      if (this.betoni.length > 1) betonit += (i + 1).toString() + ". ";
      betonit += b1 + b2 + "\n";
      totM3 += this.betoni[i].m3;
    }

    msg += "Betoni Online tilaus: " + this.keikkaId + "  \n";
    msg += pvmStringLong(this.pumppu.pumppuAika) + " ";
    msg += kestoString(this.pumppu.pumppuAika, this.pumppu.pumppuKesto) + "\n";
    msg += totM3 + "m3";
    if (this.betoni.length > 1) msg += " (" + this.betoni.length + " laatua)";
    msg += " / " + this.pumppu.pumppuPuomi + "m puomi\n";
    msg += this.asiakas.asiakasNimi + "\n";
    msg += this.tyomaa.tyomaaOsoiteString + "\n";
    msg += this.keikkaContactPerson.personPhone + "\n";
    msg += betonit;
    msg += (this.keikkaComment ? this.keikkaComment : "") + "\n";
    return msg;
  }

  get keikkaStringShort() {
    const s =
      aikaStringShort(this.pumppu.pumppuAika) +
      " " +
      this.pumppu.pumppuKesto / 60 +
      "h " +
      (this.pumppu.pumppuPuomi == 0 ? "roikko" : this.pumppu.pumppuPuomi + "m") +
      " " +
      this.tyomaa.tyomaaOsoite1;
    return s;
  }
  get keikkaString() {
    const p = (this.pumppu.isPumppu ? "P" : "B") + this.pumppu.pumppuPuomi;
    let b = "";
    for (let i = 0; i < this.betoni.length; i++) {
      const b1 = this.betoni[i].m3 + "m3 ";
      const b2 = this.betoni[i].betoniString;
      b = b + b1 + b2;
    }
    let t =
      p +
      " " +
      this.tyomaa.tyomaaString +
      " " +
      this.asiakas.asiakasNimi +
      " " +
      b +
      " " +
      this.keikkaContactPerson.personPhone +
      " " +
      this.keikkaComment;

    t = t.replaceAll("Ei tietoa", "").replaceAll("  ", " ");
    return t;
  }
  // get keikkaError, if keikka is valid, return null, otherwise return error message
  aikaError(allowEdit = undefined) {
    if (this.pumppu.ehdotaAikaa) return null;
    if (allowEdit === undefined) allowEdit = this.auth.edit;

    if (!isValidDate(this.pumppu.pumppuAika))
      if (allowEdit) return "Valitse toimitusaika";
      else return "Toimitusaikaa ei valittu";
    if (this.pumppu.pumppuAika == null)
      if (allowEdit) return "Valitse toimitusaika";
      else return "Toimitusaikaa ei ole valittu";
    if (this.pumppu.pumppuKesto == null || this.pumppu.pumppuKesto === 0)
      if (allowEdit) return "Arvioi työn kesto";
      else return "Työn kestoa ei ole arvioitu";
    if (this.tila.keikkaTilaId < 3 && this.pumppu.pumppuAika < new Date())
      return "Toimitusaika on menneisyydessä.";
    return null;
  }
  keikkaError(allowEdit = undefined) {
    if (allowEdit === undefined) allowEdit = this.auth.edit;
    return this.keikkaErrorObject(allowEdit).errorMessage;
  }
  keikkaErrorObject(allowEdit = undefined) {
    if (allowEdit === undefined) allowEdit = this.auth.edit;
    if (this.keikkaId === 0) return { isError: false, errorMessage: "", navTo: 6 };
    if (this.isLoading) return { isError: false, errorMessage: "", navTo: 6 };
    let isError = false;
    let errorMessage = null;
    // get tyomaaErrorString
    errorMessage = this.tyomaa.tyomaaError(allowEdit);
    if (errorMessage != null) return { isError: true, errorMessage: errorMessage, navTo: 1 };
    // get pumppuErrorString
    errorMessage = this.pumppu.pumppuError(allowEdit);
    if (errorMessage != null) return { isError: true, errorMessage: errorMessage, navTo: 2 };
    // get aikaErrorString
    errorMessage = this.aikaError(allowEdit);
    if (errorMessage != null) return { isError: true, errorMessage: errorMessage, navTo: 3 };
    // get betoniErrorString
    this.betoni.map((betoni) => {
      if (betoni.betoniError(allowEdit) != null) errorMessage = betoni.betoniError(allowEdit);
    });
    if (errorMessage != null) {
      // if errorMessage contains m3 then navigate to betonim3
      if (errorMessage.includes("m3"))
        return { isError: true, errorMessage: errorMessage, navTo: 9 };
      else return { isError: true, errorMessage: errorMessage, navTo: 4 };
    }
    // get asiakasErrorString
    errorMessage = this.asiakas.asiakasError(allowEdit);
    if (errorMessage != null) return { isError: true, errorMessage: errorMessage, navTo: 1 };
    // get personErrorString
    errorMessage = this.keikkaContactPerson.personError(allowEdit).errorTxt;
    if (errorMessage != null) return { isError: true, errorMessage: errorMessage, navTo: 6 };

    return { isError: isError, errorMessage: errorMessage, navTo: 6 };
  }

  //#endregion
  //#region betoni

  get betoniM3Tot() {
    {
      let m3 = 0;
      this.betoni.map((betoni) => {
        m3 += betoni.m3;
      });
      return m3;
    }
  }
  get betoniCount() {
    return this.betoni ? this.betoni.length : 0;
  }

  get getTilausOtsikko() {
    if (this.modules.hasPumppu && this.modules.hasBetoni) return "Betoni- ja pumpputilaus";
    if (this.modules.hasPumppu) return "Pumpputilaus";
    if (this.modules.hasBetoni) return "Betonitilaus";
    return "Tilaus";
  }

  get showMuokkausTilaButtonInModal() {
    if (!this.auth.isBetoniAdmin && !this.auth.isPumppuAdmin && !this.auth.isKeikkaAdmin)
      return false;
    if (!this.auth.edit && !this.auth.originalEdit) return false;
    return true;
  }

  get betoniHintaHash() {
    var _betoniHintaHash = 0;
    this.betoni.map((_betoni) => {
      _betoniHintaHash += _betoni.hinta.betoniHintaHash;
    });
    return _betoniHintaHash;
  }
  get betoniCommonHash() {
    var _betoniHash = 0;
    this.betoni.map((_betoni) => {
      _betoniHash += _betoni.betoniHash;
    });
    return _betoniHash;
  }
  get betoniUniqueHash() {
    var _betoniHash = 0;
    this.betoni.map((_betoni) => {
      _betoniHash += _betoni.betoniUniqueHash;
    });
    return _betoniHash;
  }
  // not used primary numbers
  //   71, 73, 79, 83, 89, 97
  // https://www.mathsisfun.com/numbers/prime-numbers-to-10k.html
  // primes: 2, 3, 5, 7, 11, 13, 17, 19, 23, 29, 31, 37, 41, 43, 47, 53, 59, 61, 67, 71, 73, 79, 83, 89, 97, 101, 103, 107, 109, 113
  // 127, 131, 137, 139, 149, 151, 157
  get commonHash() {
    // keep these as simple and fast as possible
    const _ajoohjeHash = hashCode(this.tyomaa.keikkaAjoOhje);
    const _commentHash = hashCode(this.keikkaComment);
    const _betoniHash = this.betoniCommonHash;
    const _pumppuHash = this.pumppu.pumppuHash;
    const _tyomaaHash = this.tyomaa.tyomaaHash;
    const _betoniToimittajaHash = this.betoniToimittaja ? this.betoniToimittaja.asiakasId : 2;
    const _pumppuToimittajaHash = this.betoniToimittaja ? this.pumppuToimittaja.asiakasId : 3;
    const _asiakasHash = this.asiakas ? this.asiakas.asiakasCommonHash : 5;
    const _laskutusHash = this.laskutus.laskutusHash;
    const _keikkaContactHash = this.keikkaContactPerson.personHash || 7;
    const _hash =
      _ajoohjeHash * 3 +
      _commentHash * 5 +
      _betoniHash * 7 +
      _pumppuHash * 11 +
      _tyomaaHash * 13 +
      _betoniToimittajaHash * 19 +
      _pumppuToimittajaHash * 37 +
      _asiakasHash * 29 +
      _laskutusHash * 31 +
      _keikkaContactHash * 43;
    return _hash;
  }
  // this is the hash that is used to check if the keikka has changed
  // do not use a difference of 5 between the primary numbers
  get uniqueHash() {
    const _loading = (this.isLoading ? 1 : 0) + (this.isLoaded ? 2 : 4);
    const _loadingbg = this.isBackgroundLoading ? 67 : 0;
    const _tilaHash = this.tila.tilaHash;
    const _authHash = this.auth.authHash; // this makes the hash personal
    const _errorHash = this.keikkaErrorTxt ? this.keikkaErrorTxt.length : 0;
    const _vehicleHash = this.pumppu.vehicle?.vehicleHash || 0;
    const _tyomaaAuthHash = this.tyomaa.auth.tyomaaAuthHash;
    const _asiakasAuthHash = this.asiakas.auth.asiakasAuthHash;
    const _starsHash = this.stars.starsHash;
    const _otsikkoHash = hashCode(this.keikkaOtsikko);
    const _betoniToimittajaHash = this.betoniToimittaja ? this.betoniToimittaja.asiakasHash : 0;
    const _pumppuToimittajaHash = this.pumppuToimittaja ? this.pumppuToimittaja.asiakasHash : 0;
    const _betoniHintaHash = this.betoniHintaHash;
    const _asiakasHash = this.asiakas ? this.asiakas.asiakasUniqueHash : 5;
    const _betoniUniqueHash = this.betoniUniqueHash;
    const _isLocked = this.isLocked ? 1 : 0;

    const _hash =
      this.keikkaId * 2 +
      _tilaHash * 17 +
      _authHash * 23 +
      _errorHash * 41 +
      _vehicleHash * 47 +
      _tyomaaAuthHash * 53 +
      _asiakasAuthHash * 59 +
      _loading * 61 +
      _loadingbg * 761 +
      _starsHash * 163 +
      _otsikkoHash * 47 +
      _betoniToimittajaHash * 73 +
      _pumppuToimittajaHash * 79 +
      _betoniHintaHash * 83 +
      _asiakasHash * 67 +
      _betoniUniqueHash * 89 +
      _isLocked * 97;
    const ab = _hash + this.commonHash;

    // check if the hash is valid ie. not NaN
    if (typeof ab !== "number") {
      console.log("INVALID TOTAL HASH", ab);
      if (typeof this.commonHash !== "number") {
        console.log("INVALID COMMON HASH", this.commonHash);
      }
      if (typeof _hash !== "number") {
        console.log("INVALID UNIQUE HASH", _hash);
        if (typeof _tilaHash !== "number") console.log("INVALID TILA HASH", _tilaHash);
        if (typeof _authHash !== "number") console.log("INVALID AUTH HASH", _authHash);
        if (typeof _errorHash !== "number") console.log("INVALID ERROR HASH", _errorHash);
        if (typeof _vehicleHash !== "number") console.log("INVALID VEHICLE HASH", _vehicleHash);
        if (typeof _tyomaaAuthHash !== "number")
          console.log("INVALID TYOMAA AUTH HASH", _tyomaaAuthHash);
        if (typeof _asiakasAuthHash !== "number")
          console.log("INVALID ASIAKAS AUTH HASH", _asiakasAuthHash);
        if (typeof _loading !== "number") console.log("INVALID LOADING HASH", _loading);
        if (typeof _loadingbg !== "number") console.log("INVALID LOADINGBG HASH", _loadingbg);
        if (typeof _starsHash !== "number") console.log("INVALID STARS HASH", _starsHash);
      }
    }
    return ab;
  }

  get varmenne() {
    try {
      const chars = 3;
      let c = sha256(this.commonHash.toString());
      c = Math.abs(hashCode(c)).toString(36);
      c = c.substring(0, chars).toUpperCase();
      return c;
    } catch (e) {
      console.log(e);
      return "ERR";
    }
  }
}

export async function getDataFromStepLogConfirmCode(confirmCode, socket) {
  try {
    socket && socket.emit("stepLog:doConfirmCode", confirmCode);

    const url1 = import.meta.env.VITE_SERVER_URL + "/api/keikka/getKeikkaIdFromCC/" + confirmCode;
    const response = await fetch(url1, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    const cResponse = await checkResponse(response, "keikkaClass.js:getDataFromStepLogConfirmCode");
    if (!cResponse.success) return false;
    return cResponse.data.recordsets[0][0];
  } catch (e) {
    console.log(e);
    return null;
  }
}

export function showToimitusBox(keikkaData, user, toimitus) {
  if (toimitus.ignore) return false;
  if (!keikkaData.tila.isToimitusAloitettu) return false;
  return (
    keikkaData.auth.isKeikkaAdmin || keikkaData.auth.isPumppari || keikkaData.asiakas.auth.edit
  );
}

export async function saveBetoniToimittajaToDB_exported(keikkaData, token, socket, personId) {
  keikkaData.handleChange.saveBetoniToimittajaToDB(
    keikkaData.keikkaId,
    keikkaData.betoniToimittaja.asiakasId,
    keikkaData.betoniToimittaja.sijaintiId,
    keikkaData.betoniToimittaja.sijaintiMatkaM,
    keikkaData.betoniToimittaja.sijaintiMatkaAika,
    token,
    socket,
    true,
    personId
  );
}
export async function savePumppuToimittajaToDB(keikkaData, token, socket) {
  keikkaData.handleChange.savePumppuToimittajaToDB(
    keikkaData.keikkaId,
    keikkaData.pumppuToimittaja.asiakasId,
    keikkaData.pumppuToimittaja.sijaintiId,
    keikkaData.pumppuToimittaja.sijaintiMatkaM,
    keikkaData.pumppuToimittaja.sijaintiMatkaAika,
    token,
    socket,
    true
  );
}
